import adminservice from "@/services/adminservice.js";

export const namespaced = true;

export const state = {
  institutionobj: {},
  questperkey: "",
  likequestions: [],
  listquestions: [],
  listinstitutions: [],
  allinstitutions: [],
  editinstitution: [],
  institutionupdated: false,
  nexttrackid: "",
  inexttrackid: "",
  editquestion: [],
  questionupdated: false,
  admininstitutions: [],
  admincategories: [],
  combosent: false,
  counters: [],
  emailsent: false,
  allusers: [],
  adminadded: {},
  qimageurl: "",
  quimageurl: "",
  Categories: [],
  questiondeleted: false,
  generalstockingdata: [],
  userstockstat: [],
  allquestions: [],
  chgavail: false,
  questocked: [],
  qsstockedstat: [],
  qssstockedstat: [],
  quesforstocks: [],
  questionsfor: [],
  topicadded: false,
  typeadded: false,
  topicfileadded: false,
  questionfileadded: false,
  categoryupdated: false,
  alltopicsarray: [],
  topicstabledata: [],
  topicsfortabledata: [],
  topicsforlistsdata: [],
  topicforedit: [],
  topicupdated: false,
  blogpostpublished: false,
  blogdraftsaved: false,
  allblogposts: [],
  blogpostslistdata: [],
  blogpostforedit: [],
  blogpostedited: false,
  imagedirectory: "default",
  allblogdrafts: [],
  blogdraftslistdata: [],
  blogdraftforedit: [],
  blogdraftedited: false,
  listtestspaces: [],
  singletestspace: {},
  testspaceupdated: false,
  organization: [],
  organizationplan: [],
  testspacestats: [],
  testspaceresults: {},
  companymetrics: {},
  organizationadmins: [],
  preparedspaceresults: [],
  staspaceresultscleared: false,
  testspacedeleted: false,
  spacetruncated: false,
  questionsflushed: false,
  partnerships: [],
  partnerorgexist: false,
  partnercode: "",
  coupons: [],
  codeexists: false,
  codeadded: false,
  coupondeleted: false,
  ambassadorsarray: [],
  ambupdated: false,
  contents: [],
  contentdeleted: false,
  contentadded: false,
  allcampaigns: [],
  discountdetails: "",
  notifications: {},
  query: "page=1&perPage=10",
  currentmodule: "Dashboard",
  newestspace: [],
  listgroups: [],
  allgroups: [],
  newgroup: {},
  unset: false
};

export const mutations = {
  ADD_INSTITUTION(state, instobj) {
    state.institutionobj = instobj;
  },
  QUEST_PER_KEY(state, quest) {
    state.questperkey = quest;
  },
  LIKE_QUESTIONS(state, likequest) {
    state.likequestions = likequest;
  },
  SET_QUESTIONS_TABLE_DATA(state, questions) {
    state.listquestions = questions;
  },
  SET_EDIT_QUESTION(state, question) {
    state.editquestion = question;
  },
  SET_NEXT_ID(state, trackid) {
    state.nexttrackid = trackid;
  },
  QUESTION_UPDATED(state) {
    state.questionupdated = true;
  },
  INSTITUTION_UPDATED(state) {
    state.institutionupdated = true;
  },
  SET_INSTITUTIONS(state, institutions) {
    state.listinstitutions = institutions;
  },
  SET_ALL_INSTITUTIONS(state, institutions) {
    state.allinstitutions = institutions;
  },
  SET_INSTITUTION(state, institution) {
    state.editinstitution = institution;
  },
  SET_INEXT_ID(state, trackid) {
    state.inexttrackid = trackid;
  },
  COMBO_SENT(state) {
    state.combosent = true;
  },
  SET_COUNTERS(state, counters) {
    state.counters = counters;
  },
  IMAGE_URL(state, url) {
    state.imageurl = url;
  },
  EMAIL_SENT(state) {
    state.emailsent = true;
  },
  ALL_USERS(state, users) {
    state.allusers = users;
  },
  ADMIN_ADDED(state, data) {
    state.adminadded = data;
  },
  SET_FILE(state, imageurl) {
    state.qimageurl = imageurl;
  },
  SET_UFILE(state, imageurl) {
    state.quimageurl = imageurl;
  },
  SET_CATEGORIES(state, types) {
    state.Categories = types;
  },
  SET_GENERAL_STOCKING_STATISTICS(state, stat) {
    state.generalstockingdata = stat;
  },
  CLEAR_STAT(state) {
    state.generalstockingdata = [];
  },
  USER_STOCKS(state, stat) {
    state.userstockstat = stat;
  },
  DELETED_QUESTIONS(state) {
    state.questiondeleted = true;
  },
  SET_ALL_QUESTIONS(state, allque) {
    state.allquestions = allque;
  },
  CHNG_AVAIL(state) {
    state.chgavail = true;
  },
  QUE_STOCKED(state, questocked) {
    state.questocked = questocked;
  },
  QSSTOCKED_STATISTICS(state, qsstocked) {
    state.qsstockedstat = qsstocked;
  },
  QSSSTOCKED_STATISTICS(state, qssstocked) {
    state.qssstockedstat = qssstocked;
  },
  SET_FOR_QUESTIONS(state, quesfor) {
    state.questionsfor = quesfor;
  },
  USER_FOR_STOCKS(state, forstocks) {
    state.quesforstocks = forstocks;
  },
  TOPIC_ADDED(state) {
    state.topicadded = true;
  },
  TYPE_ADDED(state) {
    state.typeadded = true;
  },
  TOPIC_FILE_ADDED(state) {
    state.topicfileadded = true;
  },
  QUESTION_FILE_ADDED(state) {
    state.questionfileadded = true;
  },
  CATEGORY_UPDATED(state) {
    state.categoryupdated = true;
  },
  SET_ALL_TOPICS_DATA(state, data) {
    state.alltopicsarray = data;
  },
  SET_TOPICS_TABLE_DATA(state, data) {
    state.topicstabledata = data;
  },
  SET_TOPICS_FOR_TABLE(state, data) {
    state.topicsfortabledata = data;
  },
  SET_TOPIC_FOR_LISTS(state, data) {
    state.topicsforlistsdata = data;
  },
  SET_EDIT_TOPIC(state, data) {
    state.topicforedit = data;
  },
  TOPIC_UPDATED(state) {
    state.topicupdated = true;
  },
  BLOGPOST_PUBLISHED(state) {
    state.blogpostpublished = true;
  },
  BLOGDRAFT_SAVED(state) {
    state.blogdraftsaved = true;
  },
  SET_BLOGPOSTS_ALL_DATA(state, data) {
    state.allblogposts = data;
  },
  BLOGPOSTS_LIST_STOCKS_DATA(state, data) {
    state.blogpostslistdata = data;
  },
  SET_BLOGDRAFTS_ALL_DATA(state, data) {
    state.allblogdrafts = data;
  },
  BLOGDRAFTS_LIST_STOCKS_DATA(state, data) {
    state.blogdraftslistdata = data;
  },
  SET_EDIT_BLOGPOST(state, data) {
    state.blogpostforedit = data;
  },
  BLOGPOST_EDITED(state) {
    state.blogpostedited = true;
  },
  SET_IMAGE_DIRECTORY(state, directory) {
    state.imagedirectory = directory;
  },
  SET_EDIT_BLOGDRAFT(state, data) {
    state.blogdraftforedit = data;
  },
  BLOGDRAFT_EDITED(state) {
    state.blogdraftedited = true;
  },
  SET_TESTSPACES(state, testspaces) {
    state.listtestspaces = testspaces;
  },
  SET_TESTSPACE(state, testspace) {
    state.singletestspace = testspace;
  },
  UPDATE_TESTSPACE(state) {
    state.testspaceupdated = true;
  },
  SET_ORGANIZATION(state, data) {
    state.organization = data;
  },
  SET_ORGANIZATION_PLAN(state, data) {
    state.organizationplan = data;
  },
  SET_SPACE_STATS(state, data) {
    state.testspacestats = data;
  },
  SET_SPACE_RESULTS(state, data) {
    state.testspaceresults = data;
  },
  SET_COMPANY_METRICS(state, data) {
    state.companymetrics = data;
  },
  SET_ORGANIZATION_ADMINS(state, data) {
    state.organizationadmins = data;
  },
  SET_ORGANIZATION_REMOVE_ADMIN(state, data) {
    state.organizationremoveadmin = data;
  },
  PREPARED_SPACE_RESULTS(state, data) {
    state.preparedspaceresults = data;
  },
  SPACE_RESULTS_CLEARED(state) {
    state.spaceresultscleared = true;
  },
  SPACE_DELETED(state) {
    state.testspacedeleted = true;
  },
  SPACE_USERS_TRUNCATED(state) {
    state.spacetruncated = true;
  },
  QUESTIONS_FLUSHED(state) {
    state.questionsflushed = true;
  },
  SET_PARTNERSHIPS(state, data) {
    state.partnerships = data;
  },
  PARTNER_ORG_EXISTS(state, data) {
    state.partnerorgexist = data;
  },
  PARTNER_CODE(state, data) {
    state.partnercode = data;
  },
  SET_COUPONS(state, data) {
    state.coupons = data;
  },
  SET_UNSET(state) {
    state.unset = true;
  },
  COUPON_CODE_EXISTS(state, data) {
    state.codeexists = data;
  },
  COUPON_ADDED(state) {
    state.couponadded = true;
  },
  COUPON_DELETED(state) {
    state.coupondeleted = true;
  },
  COMP_AMBASSADORS(state, data) {
    state.ambassadorsarray = data;
  },
  AMB_UPDATED(state) {
    state.ambupdated = true;
  },
  SET_CONTENTS(state, data) {
    state.contents = data;
  },
  CONTENT_ADDED(state) {
    state.contentadded = true;
  },
  CONTENT_DELETED(state) {
    state.contentdeleted = true;
  },
  SET_CAMPAIGNS(state, data) {
    state.allcampaigns = data;
  },
  SET_USERS(state, data) {
    state.allusers = data;
  },
  SET_DISCOUNT_DETAILS(state, data) {
    state.discountdetails = data;
  },
  SET_NOTIFICATIONS(state, data) {
    state.notifications = data;
  },
  SET_QUERY(state, data) {
    state.query = data;
  },
  SET_CURRENT_MODULE(state, data) {
    state.currentmodule = data;
  },
  ADD_TESTSPACE(state, data) {
    state.newestspace = data;
  },
  ADD_GROUP(state, data) {
    state.newgroup = data;
  },
  SET_GROUPS(state, groups) {
    state.listgroups = groups;
  },
  SET_ALL_GROUPS(state, groups) {
    state.allgroups = groups;
  },
  SET_GROUP(state, group) {
    state.editgroup = group;
  },
  DESTROY_ALL(state) {
    state.institutionobj = {};
    state.questperkey = "";
    state.likequestions = [];
    state.listquestions = [];
    state.listinstitutions = [];
    state.editinstitution = [];
    state.institutionupdated = false;
    state.nexttrackid = "";
    state.inexttrackid = "";
    state.editquestion = [];
    state.questionupdated = false;
    state.admininstitutions = [];
    (state.admincategories = []), (state.combosent = false);
    state.Categories = [];
  }
};

export const actions = {
  addinstitu({ commit, rootState }, instiobj) {
    commit("ADD_INSTITUTION", instiobj);
    let loggedIn = rootState.loginmaster.loggedIn;

    if (loggedIn) {
      return adminservice.addinstitution(instiobj).then(() => {});
    }
  },
  chekquestion({ commit }, quest) {
    commit("QUEST_PER_KEY", quest.question);

    return adminservice.checkquestion(quest).then(response => {
      commit("LIKE_QUESTIONS", response.data);
    });
  },
  addQuestion({ commit }, questi) {
    commit("SET_QUES", questi);
    commit("SET_UPLOADED");
    return adminservice.addQuestion(questi).then(() => {});
  },
  fetchQuestions({ commit, rootState }) {
    let trackid = rootState.loginmaster.details.trackid;
    let loggedIn = rootState.loginmaster.loggedIn;
    if (loggedIn) {
      return adminservice
        .getQuestions(trackid)
        .then(response => {
          commit("SET_QUESTIONS_TABLE_DATA", response.data);
        })
        .catch(() => {
          //console.log(error);
        });
    }
  },

  fetchQuestion({ commit, state }) {
    let trackid = state.nexttrackid;
    let curque = state.listquestions.filter(x => x.track_id == trackid);

    commit("SET_EDIT_QUESTION", curque);
  },

  fetchQuestion2({ commit }, trackid2) {
    // let trackid = state.nexttrackid;
    //let curque = state.listquestions.filter((x) => x.track_id == trackid);
    //console.log(curque)
    //commit("SET_EDIT_QUESTION", curque);
    return adminservice
      .getQuestion(trackid2)
      .then(response => {
        commit("SET_EDIT_QUESTION", response.data);
        return response.data;
      })
      .catch(() => {
        //console.log("There was an error. Error Message : " + error);
      });
  },

  setnextid({ commit }, trackid) {
    commit("SET_NEXT_ID", trackid);
  },
  setinextid({ commit }, trackid) {
    commit("SET_INEXT_ID", trackid);
  },
  setCurrentModule({ commit }, module) {
    commit("SET_CURRENT_MODULE", module);
  },
  updateQuestion({ commit, rootState }, questionobj) {
    let loggedIn = rootState.loginmaster.loggedIn;
    if (loggedIn) {
      return adminservice.updateSQuestion(questionobj).then(() => {
        commit("QUESTION_UPDATED");
      });
    }
  },
  fetchCategories({ commit, rootState }) {
    let orgname = rootState.loginmaster.details.clearance_organization;
    let loggedIn = rootState.loginmaster.loggedIn;
    if (loggedIn) {
      return adminservice
        .getCategories(orgname)
        .then(response => {
          commit("SET_CATEGORIES", response.data);
        })
        .catch(() => {
          //console.log(error);
        });
    }
  },
  fetchInstitutions({ commit, rootState, state }) {
    let orgname = rootState.loginmaster.details.org_details?.organization_name;
    let orgId = rootState.loginmaster.details.org_details?.track_id;
    return adminservice
      .getInstitutions(orgname, orgId, state.query)
      .then(response => {
        commit("SET_ALL_INSTITUTIONS", response.data);

        return response.data;
      })
      .catch(() => {
        //console.log(error);
      });
  },
  fetchInstitutionsTable({ commit, rootState, state }) {
    let orgname = rootState.loginmaster.details.org_details?.organization_name;
    let orgId = rootState.loginmaster.details.org_details?.track_id;
    return adminservice
      .getInstitutionsTable(orgname, orgId, state.query)
      .then(response => {
        commit("SET_INSTITUTIONS", response.data);
      })
      .catch(() => {
        //console.log(error);
      });
  },

  fetchInstitution({ commit }, trackid) {
    return adminservice
      .getInstitution(trackid)
      .then(response => {
        commit("SET_INSTITUTION", response.data);
        return response.data;
      })
      .catch(error => {
        console.log("There was an error. Error Message : " + error);
      });
  },
  
  updateInstitution({ commit }, institutionobj) {
    return adminservice.updateSInstitution(institutionobj).then(() => {
      commit("INSTITUTION_UPDATED");
    });
  },
  deleteInstitution({ commit }, trackid) {
    return adminservice
      .deleteInstitution(trackid)
      .then(response => {
        commit("SET_INSTITUTION", response.data);
        return response.data;
      })
      .catch(error => {
        console.log("There was an error. Error Message : " + error);
      });
  },
  addCombo({ commit }, comboObj) {
    return adminservice.sendCombo(comboObj).then(() => {
      commit("COMBO_SENT");
    });
  },
  logOut({ commit }) {
    commit("DESTROY_ALL");
  },
  getCounts({ commit }) {
    return adminservice.getCounters().then(response => {
      commit("SET_COUNTERS", response.data);
    });
  },
  uploadImage({ commit }, formData) {
    return adminservice.sendImage(formData).then(response => {
      commit("IMAGE_URL", response.data.url);
    });
  },
  setFile({ commit }, image) {
    commit("SET_FILE", image);
  },
  setUFile({ commit }, image) {
    commit("SET_UFILE", image);
  },
  emailUsers({ commit }, emailObj) {
    return adminservice.sendEmail(emailObj).then(() => {
      commit("EMAIL_SENT");
    });
  },

  getUsers({ commit }) {
    return adminservice.allUsers().then(response => {
      commit("ALL_USERS", response.data);
    });
  },
  addAdmin({ commit }, userObj) {
    return adminservice.addAdminu(userObj).then(response => {
      commit("ADMIN_ADDED", response.data);
      return response.data;
    });
  },

  perfDelete({ commit }, delobj) {
    return adminservice
      .altDelete(delobj)
      .then(response => {
        commit("DELETED_QUESTIONS", response.data);
      })
      .catch(() => {
        this.$bvModal
          .msgBoxOk(
            "Check your Network Connection. Could not Perform Delete.",
            {
              title: "No Network Connection",
              size: "xs",
              centered: true
            }
          )
          .then(() => {
            //this.deleting = false;
          });
        //console.log(error);
      });
  },

  async queryGeneralStocking({ commit }, queryobj) {
    return await adminservice.getStatisticsStock(queryobj).then(response => {
      commit("SET_GENERAL_STOCKING_STATISTICS", response.data);

      return response.data;
    });
  },
  clearstat({ commit }) {
    commit("CLEAR_STAT");
  },
  queryStocks({ commit, rootState }) {
    let trackid = rootState.loginmaster.details.trackid;
    return adminservice.getStocks(trackid).then(response => {
      commit("USER_STOCKS", response.data);
    });
  },

  fetchQuestionsall({ commit }) {
    return adminservice
      .getQuestionsall()
      .then(response => {
        commit("SET_ALL_QUESTIONS", response.data);
      })
      .catch(() => {
        //console.log(error);
      });
  },

  chngAvail({ commit }, delobj) {
    return adminservice
      .chngAvailable(delobj)
      .then(response => {
        commit("CHNG_AVAIL", response.data);
      })
      .catch(() => {
        this.$bvModal
          .msgBoxOk(
            "Check your Network Connection. Could not Perform Delete.",
            {
              title: "No Network Connection",
              size: "xs",
              centered: true
            }
          )
          .then(() => {
            //this.deleting = false;
          });
        //console.log(error);
      });
  },

  queryQStocked({ commit }) {
    return adminservice.getQStocked().then(response => {
      commit("QUE_STOCKED", response.data);
    });
  },

  queryQsStocked({ commit }, queryobj) {
    return adminservice.getQsStocked(queryobj).then(response => {
      commit("QSSTOCKED_STATISTICS", response.data);
    });
  },

  queryQsSStocked({ commit }, queryobj) {
    return adminservice.getQsSStocked(queryobj).then(response => {
      commit("QSSSTOCKED_STATISTICS", response.data);
    });
  },

  fetchForQuestions({ commit }, queryObj) {
    //let name = rootState.loginmaster.details.fullname;

    //console.log(queryObj)

    return adminservice
      .getForQuestions(queryObj)
      .then(response => {
        commit("SET_FOR_QUESTIONS", response.data);
      })
      .catch(() => {
        // console.log(error.response.status);
      });
  },
  queryForStocks({ commit }, stockobj) {
    return adminservice.getForStocks(stockobj).then(response => {
      commit("USER_FOR_STOCKS", response.data);
    });
  },
  setTopic({ commit }, topicObj) {
    return adminservice.addTopicsApi(topicObj).then(() => {
      commit("TOPIC_ADDED");
    });
  },
  setType({ commit }, typeObj) {
    return adminservice.addTypeApi(typeObj).then(() => {
      commit("TYPE_ADDED");
    });
  },
  setTopicFileObj({ commit }, topicFileObj) {
    return adminservice.addTopicsFileApi(topicFileObj).then(() => {
      commit("TOPIC_FILE_ADDED");
    });
  },
  setQuestionFileObj({ commit }, questionFileObj) {
    return adminservice.addQuestionsFileApi(questionFileObj).then(() => {
      commit("QUESTION_FILE_ADDED");
    });
  },
  updatecategory({ commit }, categoryobj) {
    return adminservice.updateServicecategory(categoryobj).then(() => {
      commit("CATEGORY_UPDATED");
    });
  },
  fetchAllTopics({ commit, rootState }) {
    let orgname = rootState.loginmaster.details.clearance_organization;
    // let trackid = rootState.loginmaster.details.trackid;
    return adminservice
      .getAllTopics(orgname)
      .then(response => {
        commit("SET_ALL_TOPICS_DATA", response.data);
      })
      .catch(() => {
        //console.log(error);
      });
  },
  fetchTopicStocks({ commit, rootState }) {
    let orgname = rootState.loginmaster.details.clearance_organization;
    // let trackid = rootState.loginmaster.details.trackid
    return adminservice.getTopicStocks(orgname).then(response => {
      commit("SET_TOPICS_TABLE_DATA", response.data);
    });
  },
  fetchForTopics({ commit }, queryObj) {
    return adminservice
      .getForTopics(queryObj)
      .then(response => {
        commit("SET_TOPICS_FOR_TABLE", response.data);
      })
      .catch(error => {
        return error.response.status;
      });
  },
  queryForTopicStocks({ commit }, stockobj) {
    return adminservice.getForTopicStocks(stockobj).then(response => {
      commit("SET_TOPIC_FOR_LISTS", response.data);
    });
  },
  fetchTopic({ commit, state }) {
    let trackid = state.nexttrackid;
    let topicforedit = state.alltopicsarray.filter(x => x.track_id == trackid);

    commit("SET_EDIT_TOPIC", topicforedit);
  },

  updateTopic({ commit }, topicObj) {
    return adminservice.updateServiceTopic(topicObj).then(() => {
      commit("TOPIC_UPDATED");
    });
  },

  publishBlogpost({ commit }, postObj) {
    return adminservice.publishServiceBlogpost(postObj).then(() => {
      commit("BLOGPOST_PUBLISHED");
    });
  },
  saveBlogdraft({ commit }, draftObj) {
    return adminservice.saveServiceBlogdraft(draftObj).then(() => {
      commit("BLOGDRAFT_SAVED");
    });
  },
  fetchBlogs({ commit }) {
    //let trackid = rootState.loginmaster.details.trackid;
    return adminservice
      .getAllBlogs()
      .then(response => {
        commit("SET_BLOGPOSTS_ALL_DATA", response.data);
      })
      .catch(() => {
        //console.log(error);
      });
  },
  queryBlogs({ commit }) {
    return adminservice.getBlogStocks().then(response => {
      commit("BLOGPOSTS_LIST_STOCKS_DATA", response.data);
    });
  },
  fetchBlogpost({ commit, state }) {
    let trackid = state.nexttrackid;
    let blogpostforedit = state.allblogposts.filter(x => x.track_id == trackid);

    commit("SET_EDIT_BLOGPOST", blogpostforedit);
  },
  saveBlogpostChanges({ commit }, postObj) {
    return adminservice.saveServiceBlogpostChanges(postObj).then(() => {
      commit("BLOGPOST_EDITED");
    });
  },
  setImageDirectory({ commit }, directory) {
    commit("SET_IMAGE_DIRECTORY", directory);
  },
  fetchBlogdrafts({ commit }) {
    //let trackid = rootState.loginmaster.details.trackid;
    return adminservice
      .getAllBlogdrafts()
      .then(response => {
        commit("SET_BLOGDRAFTS_ALL_DATA", response.data);
      })
      .catch(() => {
        //console.log(error);
      });
  },
  queryBlogdrafts({ commit }) {
    return adminservice.getBlogdraftsStocks().then(response => {
      commit("BLOGDRAFTS_LIST_STOCKS_DATA", response.data);
    });
  },
  fetchBlogdraft({ commit, state }) {
    let trackid = state.nexttrackid;
    let blogdraftforedit = state.allblogdrafts.filter(
      x => x.track_id == trackid
    );

    commit("SET_EDIT_BLOGDRAFT", blogdraftforedit);
  },
  saveBlogdraftChanges({ commit }, draftObj) {
    return adminservice.saveServiceBlogdraftChanges(draftObj).then(() => {
      commit("BLOGDRAFT_EDITED");
    });
  },
  createTestspace({ commit }, testspaceObj) {
    commit("ADD_TESTSPACE", testspaceObj);

    return adminservice.addTestspace(testspaceObj).then(response => {
      return response;
    });
  },
  setQuery({ commit }, query) {
    commit("SET_QUERY", query);
  },
  fetchTestspaces({ commit, state, rootState }) {
    let orgname = rootState.loginmaster.details.clearance_organization;
    let orgId = rootState.loginmaster.details.clearance_organization_id;
    return adminservice
      .getTestspaces(orgname, orgId, state.query)
      .then(response => {
        commit("SET_TESTSPACES", response.data);
      })
      .catch(() => {
        //console.log(error);
      });
  },
  
  fetchTestspacesAnalytics({ commit, rootState }) {
    let orgId = rootState.loginmaster.details.clearance_organization_id;
    return adminservice
      .getTestspacesAnalytics(orgId)
      .then(response => {
        commit("SET_GROUPS", response.data);

        return response.data;
      })
      .catch(() => {
        //console.log(error);
      });
  },

  fetchTestgroupsAnalytics({ commit, rootState }) {
    let orgId = rootState.loginmaster.details.clearance_organization_id;
    return adminservice
      .getTestgroupsAnalytics(orgId)
      .then(response => {
        commit("SET_GROUPS", response.data);

        return response.data;
      })
      .catch(() => {
        //console.log(error);
      });
  },
  

  fetchTestspace({ commit }, id) {
    return adminservice
      .getTestspace(id)
      .then(response => {
        commit("SET_TESTSPACE", response.data);
        return response.data;
      })
      .catch(error => {
        return error;
        //console.log(error);
      });
  },

  createGroup({ commit }, groupObj) {
    commit("ADD_GROUP", groupObj);

    return adminservice.createGroup(groupObj).then(response => {
      return response;
    });
  },

  updateGroup({ commit }, groupObj) {
    commit("ADD_GROUP", groupObj);

    return adminservice.updateGroup(groupObj).then(response => {
      return response;
    });
  },

  fetchAllGroups({ commit, rootState }) {
    let orgId = rootState.loginmaster.details.clearance_organization_id;
    return adminservice
      .getAllGroups(orgId)
      .then(response => {
        commit("SET_GROUPS", response.data);

        return response.data;
      })
      .catch(() => {
        //console.log(error);
      });
  },

  fetchGroupsTable({ commit, state, rootState }) {
    let orgId = rootState.loginmaster.details.clearance_organization_id;
    return adminservice
      .getGroupsTable(orgId, state.query)
      .then(response => {
        commit("SET_GROUPS", response.data);

        return response.data;
      })
      .catch(() => {
        //console.log(error);
      });
  },

  fetchGroupsAnalytics({ commit, rootState }) {
    let orgId = rootState.loginmaster.details.clearance_organization_id;
    return adminservice
      .getGroupsAnalytics(orgId)
      .then(response => {
        commit("SET_GROUPS", response.data);

        return response.data;
      })
      .catch(() => {
        //console.log(error);
      });
  },

  fetchSingleGroup({ commit }, id) {
    return adminservice
      .getSingleGroup(id)
      .then(response => {
        commit("SET_GROUP", response.data);
        return response.data;
      })
      .catch(error => {
        return error;
        //console.log(error);
      });
  },

  deleteGroup({ commit }, id) {
    return adminservice
      .deleteGroup(id)
      .then(response => {
        commit("SET_GROUP", response.data);
        return response.data;
      })
      .catch(error => {
        return error;
        //console.log(error);
      });
  },

  truncateGroup({ commit }, id) {
    return adminservice
      .truncateGroup(id)
      .then(response => {
        commit("SET_GROUP", response.data);
        return response.data;
      })
      .catch(error => {
        return error;
        //console.log(error);
      });
  },

  createCandidate({ commit }, payload) {
    commit("ADD_GROUP", payload);

    return adminservice.createCandidate(payload).then(response => {
      return response;
    });
  },

  importCandidates({ commit }, payload) {
    commit("ADD_GROUP", payload);

    return adminservice.importCandidates(payload).then(response => {
      return response;
    });
  },

  updateCandidate({ commit }, payload) {
    commit("ADD_GROUP", payload);

    return adminservice.updateCandidate(payload).then(response => {
      return response;
    });
  },

  deleteCandidate({ commit }, id) {
    commit("ADD_GROUP", id);

    return adminservice.deleteCandidate(id).then(response => {
      return response;
    });
  },

  fetchAllCandidates({ commit, state }, groupId) {
    return adminservice
      .getAllCandidates(groupId, state.query)
      .then(response => {
        commit("SET_GROUPS", response.data);

        return response.data;
      })
      .catch(() => {
        //console.log(error);
      });
  },

  fetchCandidatesTable({ commit, state }, groupId) {
    return adminservice
      .getCandidatesTable(groupId, state.query)
      .then(response => {
        commit("SET_GROUPS", response.data);

        return response.data;
      })
      .catch(() => {
        //console.log(error);
      });
  },

  fetchSingleCandidate({ commit }, id) {
    return adminservice
      .getSingleCandidate(id)
      .then(response => {
        commit("SET_GROUP", response.data);
        return response.data;
      })
      .catch(error => {
        return error;
        //console.log(error);
      });
  },

  fetchCompetitions({ commit, state, rootState }) {
    let orgname = rootState.loginmaster.details.clearance_organization;
    let orgId = rootState.loginmaster.details.clearance_organization_id;
    return adminservice
      .getCompetitions(orgname, orgId, state.query)
      .then(response => {
        commit("SET_TESTSPACES", response.data);
      })
      .catch(() => {
        //console.log(error);
      });
  },

  fetchCompetition({ commit }, id) {
    return adminservice
      .getCompetition(id)
      .then(response => {
        commit("SET_TESTSPACE", response.data);
        return response.data;
      })
      .catch(error => {
        return error;
        //console.log(error);
      });
  },

  updateTestspace({ commit }, testspaceobj) {
    return adminservice.updateSTestspace(testspaceobj).then(response => {
      commit("ADD_TESTSPACE", testspaceobj);
      return response;
    });
  },
  fetchOrganization({ commit, rootState }) {
    let orgname = rootState.loginmaster.details.clearance_organization;

    return adminservice
      .getOrganization(orgname)
      .then(response => {
        commit("SET_ORGANIZATION", response.data);
      })
      .catch(() => {
        //console.log(error);
      });
  },
  fetchOrganizationplan({ commit, rootState }) {
    let orgname = rootState.loginmaster.details.clearance_organization;
    return adminservice
      .getOrganizationplan(orgname)
      .then(response => {
        commit("SET_ORGANIZATION_PLAN", response.data);
      })
      .catch(() => {
        //console.log(error);
      });
  },
  updateOrganization({ commit }, orgObj) {
    return adminservice.setOrganization(orgObj).then(response => {
      commit("SET_ORGANIZATION", response.data);
    });
  },
  fetchSpacestats({ commit }, spaceid) {
    return adminservice.getSpacestats(spaceid.spaceid).then(response => {
      commit("SET_SPACE_STATS", response.data);
    });
  },
  fetchSpaceresults({ commit }, spaceid) {
    return adminservice.getSpaceresults(spaceid.spaceid).then(response => {
      commit("SET_SPACE_RESULTS", response.data);
    });
  },
  fetchCompanymetrics({ commit }) {
    return adminservice.getCompanymetrics().then(response => {
      commit("SET_COMPANY_METRICS", response.data);
    });
  },
  fetchOrgadmins({ commit }, OrgObj) {
    return adminservice.getOrgadmins(OrgObj).then(response => {
      commit("SET_ORGANIZATION_ADMINS", response.data);
    });
  },
  delAdmin({ commit }, userObj) {
    return adminservice.removeAdmin(userObj).then(response => {
      commit("SET_ORGANIZATION_REMOVE_ADMIN", response.data);
    });
  },
  prepareSpaceresults({ commit }, prepareObj) {
    return adminservice.prepareResults(prepareObj).then(response => {
      commit("PREPARED_SPACE_RESULTS", response.data);
      return response.data;
    });
  },
  DownloadSpaceresults({ commit }, prepareObj) {
    return adminservice.DownloadResults(prepareObj).then(response => {
      commit("PREPARED_SPACE_RESULTS", response.data);
      return response.data;
    });
  },
  clearResultsops({ commit }, spacetrackid) {
    return adminservice.performSpaceclear(spacetrackid).then(response => {
      commit("SPACE_RESULTS_CLEARED");
      return response.data;
    });
  },
  deleteSpaceops({ commit }, spacetrackid) {
    return adminservice.performSpacedelete(spacetrackid).then(response => {
      commit("SPACE_DELETED");
      return response.data;
    });
  },
  truncateUsersops({ commit }, spacetrackid) {
    return adminservice.performSpacetruncate(spacetrackid).then(response => {
      commit("SPACE_USERS_TRUNCATED");
      return response.data;
    });
  },
  flushForQuestions({ commit }, stockObj) {
    return adminservice.flushOutQuestions(stockObj).then(() => {
      commit("QUESTIONS_FLUSHED");
      // return response.data
    });
  },
  prepareForDownload({ commit }, stockObj) {
    return adminservice.prepareDownloadQuestions(stockObj).then(response => {
      commit("QUESTIONS_DOWNLOAD_PREPARED");
      return response.data;
    });
  },
  fetchPartnerships({ commit }) {
    return adminservice.getPartnerships().then(response => {
      commit("SET_PARTNERSHIPS", response.data);
    });
  },
  checkPartOrganization({ commit }, payload) {
    return adminservice.checkPartnerOrganization(payload).then(response => {
      commit("PARTNER_ORG_EXISTS", response.data);
      return response.data;
    });
  },
  createPartnership({ commit }, payload) {
    return adminservice.createePartnership(payload).then(response => {
      commit("PARTNER_CODE", "");
      return response.data;
    });
  },
  generatePartCode({ commit }, payload) {
    return adminservice.generatePartnerCode(payload).then(response => {
      commit("PARTNER_CODE", response.data);
      return response.data;
    });
  },
  checkCoupon({ commit }, couponcode) {
    return adminservice.checkCouponcode(couponcode).then(response => {
      commit("COUPON_CODE_EXISTS", response.data);
      return response.data;
    });
  },
  fetchCoupons({ commit, rootState }) {
    let admintrackid = rootState.loginmaster.details.trackid;
    let clearance_level = rootState.loginmaster.details.clearance_level;

    return adminservice
      .getCoupons(admintrackid, clearance_level)
      .then(response => {
        commit("SET_COUPONS", response.data);
      });
  },
  addCoupons({ commit }, couponObj) {
    return adminservice.setCoupons(couponObj).then(() => {
      commit("COUPONS_ADDED");
    });
  },

  editCoupons({ commit }, couponObj) {
    return adminservice.updateCoupons(couponObj).then(() => {
      commit("COUPONS_ADDED");
    });
  },
  delcoupon({ commit }, couponObj) {
    return adminservice.deleteCoupon(couponObj).then(() => {
      commit("COUPON_DELETED");
    });
  },
  fetchAmbassadors({ commit }) {
    return adminservice.getAmbassadors().then(response => {
      commit("COMP_AMBASSADORS", response.data);
    });
  },
  paidPayout({ commit }, payoutObj) {
    return adminservice.setPaidpayout(payoutObj).then(() => {
      commit("AMB_UPDATED");
    });
  },
  approvePayout({ commit }, payoutObj) {
    return adminservice.setApprovepayout(payoutObj).then(() => {
      commit("AMB_UPDATED");
    });
  },
  disapprovePayout({ commit }, payoutObj) {
    return adminservice.setDisapprovepayout(payoutObj).then(() => {
      commit("AMB_UPDATED");
    });
  },
  fetchContents({ commit, rootState }) {
    let admintrackid = rootState.loginmaster.details.trackid;
    let clearance_level = rootState.loginmaster.details.clearance_level;

    return adminservice
      .getContents(admintrackid, clearance_level)
      .then(response => {
        commit("SET_CONTENTS", response.data);
      });
  },
  addContents({ commit }, contentObj) {
    return adminservice.setContents(contentObj).then(() => {
      commit("CONTENTS_ADDED");
    });
  },

  editContents({ commit }, contentObj) {
    return adminservice.updateContents(contentObj).then(() => {
      commit("CONTENTS_ADDED");
    });
  },
  delContent({ commit }, contentObj) {
    return adminservice.deleteContent(contentObj).then(() => {
      commit("CONTENT_DELETED");
    });
  },
  sendContent({ commit }, sendObj) {
    return adminservice.sendoutContent(sendObj).then(() => {
      commit("CONTENTS_SENT");
    });
  },
  fetchCampaigns({ commit }) {
    return adminservice.getCampaigns().then(response => {
      commit("SET_CAMPAIGNS", response.data);
    });
  },

  continueCampaign({ commit }, trackid) {
    return adminservice.continuingCampaign(trackid).then(() => {
      commit("CONTENTS_ADDED");
    });
  },

  getAllUsers({ commit }) {
    return adminservice.$_getAllUsers().then(response => {
      commit("SET_USERS", response.data);
    });
  },

  fetchDiscountDetails({ commit }) {
    return adminservice.$_getDiscountDetails().then(response => {
      commit("SET_DISCOUNT_DETAILS", response.data.data);
    });
  },

  setDiscount({ commit }, discountObj) {
    return adminservice.setDiscountSeason(discountObj).then(() => {
      commit("SET_DISCOUNT_DETAILS");
    });
  },
  setNotification({ commit }, noti) {
    return adminservice.createNotification(noti).then(() => {
      commit("SET_UNSET");
    });
  },
  getOrgAnalytics({ commit, rootState }) {
    let orgId = rootState.loginmaster.details.org_details?.track_id;
    return adminservice.$_getOrgAnalytics(orgId).then(response => {
      commit("SET_UNSET");

      return response.data;
    });
  },
  fetchNotifications({ commit }) {
    return adminservice.getNotifications().then(response => {
      commit("SET_NOTIFICATIONS", response.data.data);
    });
  },
  updateNotification({ commit }, noti) {
    return adminservice.setUpdateNotification(noti).then(() => {
      commit("SET_UNSET");
    });
  },
  delnotification({ commit }, id) {
    return adminservice.deleteNotification(id).then(() => {
      commit("CONTENT_DELETED");
    });
  },
  checkAmbassador({ commit }, ambassadorcode) {
    return adminservice.checkAmbassadorcode(ambassadorcode).then(response => {
      commit("COUPON_CODE_EXISTS", response.data);
      return response.data;
    });
  },
  addAmbassadors({ commit }, ambassadorObj) {
    return adminservice.setAmbassadors(ambassadorObj).then(() => {
      commit("COUPONS_ADDED");
    });
  },

  editAmbassadors({ commit }, ambassadorObj) {
    return adminservice.updateAmbassadors(ambassadorObj).then(() => {
      commit("COUPONS_ADDED");
    });
  },
  perfTopicDelete({ commit }, delobj) {
    return adminservice
      .altDeleteTopic(delobj)
      .then(response => {
        commit("DELETED_QUESTIONS", response.data);
      })
      .catch(() => {
        this.$bvModal
          .msgBoxOk(
            "Check your Network Connection. Could not Perform Delete.",
            {
              title: "No Network Connection",
              size: "xs",
              centered: true
            }
          )
          .then(() => {
            //this.deleting = false;
          });
      });
  },
  downloadExampleFile({ commit, rootState }, { downloadType, fileType }) {
    let environment = rootState.loginmaster.environ;
    return adminservice
      .downloadExampleFile(downloadType, fileType, environment)
      .then(response => {
        commit("SET_GROUPS", response.data);

        return response.data;
      })
      .catch(() => {
        //console.log(error);
      });
  },
};

export const getters = {
  retrievecategory: state => trackid => {
    return state.Categories.filter(x => x.track_id == trackid).map(x => x.name);
  }
};
